module.exports = __webpack_public_path__ + "media/images/tests/finish-79c9d1d5ffa3e94a594ed997b42dc369.png";